  import { getCrmColors } from "../../theme/crmColors";
import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import ContactModal from "../ContactModal";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Grid, ListItemText, MenuItem, Select } from "@material-ui/core";
import { toast } from "react-toastify";
import { AddComment, Facebook, Instagram, WhatsApp } from "@material-ui/icons";
import ShowTicketOpen from "../ShowTicketOpenModal";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 8,
    background: theme.mode === "light" ? "#ffffff" : (theme.ticketDark ? getCrmColors(theme, "dark").surface : "#2f2f2f"),
    color: theme.mode === "light" ? "#172033" : (theme.ticketDark ? "#FFFFFF" : "#f8fafc"),
    boxShadow: theme.mode === "light" ? "0 24px 60px rgba(15, 23, 42, 0.18)" : "0 24px 60px rgba(0,0,0,0.42)",
    overflow: "hidden"
  },
  dialogTitle: {
    padding: theme.spacing(2, 2.5),
    background: theme.mode === "light" ? "linear-gradient(135deg, #ffffff 0%, #edf6ff 100%)" : (theme.ticketDark ? getCrmColors(theme, "dark").inset : "#343434"),
    borderBottom: theme.mode === "light" ? "1px solid #e6edf6" : (theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : "1px solid rgba(255,255,255,0.08)")
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25)
  },
  titleIcon: {
    width: 42,
    height: 42,
    borderRadius: 8,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").accentSoft : theme.palette.primary.main,
    color: "#ffffff",
    boxShadow: theme.mode === "light" ? "0 10px 22px rgba(93, 170, 252, 0.22)" : "0 10px 22px rgba(0,0,0,0.24)"
  },
  titleEyebrow: {
    fontSize: 11,
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    color: theme.mode === "light" ? "#315b8f" : "#9ccaef"
  },
  titleText: {
    fontSize: 22,
    lineHeight: 1.1,
    fontWeight: 900,
    color: theme.mode === "light" ? "#0f172a" : (theme.ticketDark ? "#FFFFFF" : "#f8fafc")
  },
  dialogContent: {
    padding: theme.spacing(2.25),
    background: theme.mode === "light" ? "#f4f7fb" : (theme.ticketDark ? getCrmColors(theme, "dark").background : "#424242"),
    borderTop: 0,
    borderBottom: 0,
    "& .MuiInputLabel-root": {
      color: theme.mode === "light" ? "#64748b" : (theme.ticketDark ? "#FFFFFF" : "#cbd5e1")
    }
  },
  formGrid: {
    width: "100%",
    padding: theme.spacing(1.5),
    borderRadius: 8,
    background: theme.mode === "light" ? "#ffffff" : (theme.ticketDark ? getCrmColors(theme, "dark").surface : "#2f2f2f"),
    border: theme.mode === "light" ? "1px solid #d9e2ef" : (theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : "1px solid rgba(255,255,255,0.08)"),
    boxShadow: theme.mode === "light" ? "0 8px 18px rgba(15, 23, 42, 0.04)" : "0 10px 24px rgba(0,0,0,0.14)"
  },
  field: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: theme.mode === "light" ? "#ffffff" : (theme.ticketDark ? getCrmColors(theme, "dark").inset : "#343434"),
      color: theme.mode === "light" ? "#172033" : (theme.ticketDark ? "#FFFFFF" : "#f8fafc"),
      "& fieldset": {
        borderColor: theme.mode === "light" ? "#d7e1ee" : (theme.ticketDark ? getCrmColors(theme, "dark").border : "rgba(255,255,255,0.12)")
      },
      "&:hover fieldset": {
        borderColor: theme.mode === "light" ? "#c6d4e6" : "rgba(255,255,255,0.20)"
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
        boxShadow: theme.mode === "light" ? "0 0 0 3px rgba(93, 170, 252, 0.12)" : "0 0 0 3px rgba(93, 170, 252, 0.14)"
      }
    },
    "& .MuiSelect-icon": {
      color: theme.mode === "light" ? "#64748b" : (theme.ticketDark ? "#FFFFFF" : "#dbeafe")
    }
  },
  dialogActions: {
    padding: theme.spacing(1.5, 2.5),
    background: theme.mode === "light" ? "#ffffff" : (theme.ticketDark ? getCrmColors(theme, "dark").surface : "#2f2f2f"),
    borderTop: theme.mode === "light" ? "1px solid #e6edf6" : (theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : "1px solid rgba(255,255,255,0.08)")
  },
  cancelButton: {
    borderRadius: 8,
    fontWeight: 800,
    textTransform: "uppercase",
    color: theme.mode === "light" ? "#64748b" : (theme.ticketDark ? "#FFFFFF" : "#dbeafe"),
    borderColor: theme.mode === "light" ? "#d7e1ee" : "rgba(255,255,255,0.14)"
  },
  saveButton: {
    borderRadius: 8,
    fontWeight: 800,
    textTransform: "uppercase",
    boxShadow: theme.mode === "light" ? "0 10px 22px rgba(93, 170, 252, 0.22)" : "0 10px 22px rgba(0,0,0,0.24)"
  },
  online: {
    fontSize: 11,
    color: "#25d366"
  },
  offline: {
    fontSize: 11,
    color: "#e1306c"
  }
}));

const filter = createFilterOptions({
  trim: true,
});

const NewTicketModal = ({ modalOpen, onClose, initialContact }) => {
  const classes = useStyles();
  const [options, setOptions] = useState([]);
  const [channelFilter, setChannelFilter] = useState(null);

  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState("");
  const [selectedWhatsapp, setSelectedWhatsapp] = useState("");
  const [newContact, setNewContact] = useState({});
  const [whatsapps, setWhatsapps] = useState([]);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const { companyId, whatsappId } = user;

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");

  useEffect(() => {
    if (initialContact?.id !== undefined) {
      setOptions([initialContact]);
      setSelectedContact(initialContact);
    }
  }, [initialContact]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        api
          // .get(`/whatsapp/filter`, { params: { companyId, session: 0, channel: channelFilter } })
          .get(`/whatsapp`, { params: { companyId, session: 0 } })
          .then(({ data }) => setWhatsapps(data));

          // .then(({ data }) => {
          //   const mappedWhatsapps = data.map((whatsapp) => ({
          //     ...whatsapp,
          //     selected: false,
          //   }));
          //   setWhatsapps(mappedWhatsapps);
          //   if (channelFilter && mappedWhatsapps.length && mappedWhatsapps?.length === 1 && (user.whatsappId === null || user?.whatsapp?.channel !== channelFilter)) {
          //     setSelectedWhatsapp(mappedWhatsapps[0].id)
          //   }
          // });
      };

      if (whatsappId !== null && whatsappId !== undefined) {
        setSelectedWhatsapp(whatsappId)
      }

      if (user.queues.length === 1) {
        setSelectedQueue(user.queues[0].id)
      }
      fetchContacts();
      setLoading(false);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [selectedContact, channelFilter])

  useEffect(() => {
    if (!modalOpen || searchParam.length < 3) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("contacts", {
            params: { searchParam },
          });
          setOptions(data.contacts);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, modalOpen]);

  const IconChannel = (channel) => {
    switch (channel) {
      case "facebook":
        return <Facebook style={{ color: "#3b5998", verticalAlign: "middle" }} />;
      case "instagram":
        return <Instagram style={{ color: "#e1306c", verticalAlign: "middle" }} />;
      case "whatsapp":
        return <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />
      default:
        return "error";
    }
  };

  const handleClose = () => {
    onClose();
    setSearchParam("");
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
    setSelectedContact(null);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setLoading(false);
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
  };

  const handleSaveTicket = async contactId => {
    if (!contactId) return;
    // if (selectedQueue === "" && user.profile !== 'admin') {
    if (selectedQueue === "") {
      toast.error("Selecione uma fila");
      return;
    }

    setLoading(true);
    try {
      const queueId = selectedQueue !== "" ? selectedQueue : null;
      const whatsappId = selectedWhatsapp !== "" ? selectedWhatsapp : null;
      const { data: ticket } = await api.post("/tickets", {
        contactId: contactId,
        queueId,
        whatsappId,
        userId: user.id,
        status: "open",
      });

      onClose(ticket);
    } catch (err) {

      const ticket = JSON.parse(err.response.data.error);

      if (ticket.userId !== user?.id) {
        setOpenAlert(true);
        setUserTicketOpen(ticket?.user?.name);
        setQueueTicketOpen(ticket?.queue?.name);
      } else {
        setOpenAlert(false);
        setUserTicketOpen("");
        setQueueTicketOpen("");
        setLoading(false);
        onClose(ticket);
      }
    }
    setLoading(false);
  };

  const handleSelectOption = (e, newValue) => {
    if (newValue?.number) {
      setSelectedContact(newValue);
    } else if (newValue?.name) {
      setNewContact({ name: newValue.name });
      setContactModalOpen(true);
    }
  };

  const handleCloseContactModal = () => {
    setContactModalOpen(false);
  };

  const handleAddNewContactTicket = contact => {
    setSelectedContact(contact);
  };

  const createAddContactOption = (filterOptions, params) => {
    const filtered = filter(filterOptions, params);
    if (params.inputValue !== "" && !loading && searchParam.length >= 3) {
      filtered.push({
        name: `${params.inputValue}`,
      });
    }
    return filtered;
  };

  const renderOption = option => {
    if (option.number) {
      return <>
        {IconChannel(option.channel)}
        <Typography component="span" style={{ fontSize: 14, marginLeft: "10px", display: "inline-flex", alignItems: "center", lineHeight: "2" }}>
          {option.name} - {option.number}
        </Typography>
      </>
    } else {
      return `${i18n.t("newTicketModal.add")} ${option.name}`;
    }
  };

  const renderOptionLabel = option => {
    if (option.number) {
      return `${option.name} - ${option.number}`;
    } else {
      return `${option.name}`;
    }
  };

  const renderContactAutocomplete = () => {
    if (initialContact === undefined || initialContact.id === undefined) {
      return (
        <Grid xs={12} item>
          <Autocomplete
            fullWidth
            options={options}
            loading={loading}
            clearOnBlur
            autoHighlight
            freeSolo
            clearOnEscape
            getOptionLabel={renderOptionLabel}
            renderOption={renderOption}
            filterOptions={createAddContactOption}
            onChange={(e, newValue) => {                     
              setChannelFilter(newValue ? newValue.channel : "whatsapp");
              handleSelectOption(e, newValue)
            }}
            renderInput={params => (
              <TextField
                {...params}
                label={i18n.t("newTicketModal.fieldLabel")}
                variant="outlined"
                autoFocus
                className={classes.field}
                onChange={e => setSearchParam(e.target.value)}
                onKeyPress={e => {
                  if (loading || !selectedContact) return;
                  else if (e.key === "Enter") {
                    handleSaveTicket(selectedContact.id);
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      )
    }
    return null;
  }

  return (
    <>

      <Dialog
        open={modalOpen}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle id="form-dialog-title" disableTypography className={classes.dialogTitle}>
          <div className={classes.titleRow}>
            <div className={classes.titleIcon}>
              <AddComment />
            </div>
            <div>
              <Typography className={classes.titleEyebrow}>
                Atendimento
              </Typography>
              <Typography className={classes.titleText}>
                {i18n.t("newTicketModal.title")}
              </Typography>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers className={classes.dialogContent}>
          <Grid className={classes.formGrid} container spacing={2}>
            {/* CONTATO */}
            {renderContactAutocomplete()}
            {/* FILA */}
            <Grid xs={12} item>
              <Select
                required
                fullWidth
                displayEmpty
                variant="outlined"
                className={classes.field}
                value={selectedQueue}
                onChange={(e) => {
                  setSelectedQueue(e.target.value)
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  if (selectedQueue === "") {
                    return "Selecione uma fila"
                  }
                  const queue = user.queues.find(q => q.id === selectedQueue)
                  return queue.name
                }}
              >
                {user.queues?.length > 0 &&
                  user.queues.map((queue, key) => (
                    <MenuItem dense key={key} value={queue.id}>
                      <ListItemText primary={queue.name} />
                    </MenuItem>
                  ))
                }
              </Select>
            </Grid>
            {/* CONEXAO */}
            <Grid xs={12} item>
              <Select
                required
                fullWidth
                displayEmpty
                variant="outlined"
                className={classes.field}
                value={selectedWhatsapp}
                onChange={(e) => {
                  setSelectedWhatsapp(e.target.value)
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  if (selectedWhatsapp === "") {
                    return "Selecione uma Conexão"
                  }
                  const whatsapp = whatsapps.find(w => w.id === selectedWhatsapp)
                  return whatsapp?.name
                }}
              >
                {whatsapps?.length > 0 &&
                  whatsapps.map((whatsapp, key) => (
                    <MenuItem dense key={key} value={whatsapp.id}>
                      <ListItemText
                        primary={
                          <>
                            {IconChannel(whatsapp.channel)}
                            <Typography component="span" style={{ fontSize: 14, marginLeft: "10px", display: "inline-flex", alignItems: "center", lineHeight: "2" }}>
                              {whatsapp.name} &nbsp; <p className={(whatsapp.status) === 'CONNECTED' ? classes.online : classes.offline} >({whatsapp.status})</p>
                            </Typography>
                          </>
                        }
                      />
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            type="button"
            onClick={handleClose}
            color="secondary"
            disabled={loading}
            variant="outlined"
            className={classes.cancelButton}
          >
            {i18n.t("newTicketModal.buttons.cancel")}
          </Button>
          <ButtonWithSpinner
            variant="contained"
            type="button"
            disabled={!selectedContact}
            onClick={() => handleSaveTicket(selectedContact.id)}
            color="primary"
            loading={loading}
            className={classes.saveButton}
          >
            {i18n.t("newTicketModal.buttons.ok")}
          </ButtonWithSpinner>
        </DialogActions>
        {contactModalOpen && (
          <ContactModal
            open={contactModalOpen}
            initialValues={newContact}
            onClose={handleCloseContactModal}
            onSave={handleAddNewContactTicket}
          ></ContactModal>
        )}
        {openAlert && (
          <ShowTicketOpen
            isOpen={openAlert}
            handleClose={handleCloseAlert}
            user={userTicketOpen}
            queue={queueTicketOpen}
          />
        )}
      </Dialog >
    </>
  );
};
export default NewTicketModal;
